import { buildMenuCategories } from '@root/components/v2/SideOverlayTabMenu/buildMenuCategories';
import { Activity, Info } from 'lucide-react';

// Vertical menu of the stacked workload vulnerability side overlay, keyed by its `currentSubTab`.
const WORKLOAD_VULNERABILITY_TABS = {
  Details: { label: 'Details', icon: Info },
  'Runtime Analysis': { label: 'Runtime Analysis', icon: Activity },
};

// Only two tabs, so they are listed flat, without group headers.
export const WORKLOAD_VULNERABILITY_MENU_CATEGORIES = buildMenuCategories(
  Object.keys(WORKLOAD_VULNERABILITY_TABS),
  undefined,
  key => ({ key, ...WORKLOAD_VULNERABILITY_TABS[key] }),
);
